export default "__VITE_ASSET__BOuK88UI__"